import { http } from './config/config-receituario'

export default {
  importarPreviewProdutos: (token, arquivo, previewProdutos = true) => {
    const formData = new FormData()
    formData.append('arquivo', arquivo)

    if (previewProdutos !== undefined) {
      formData.append('previewProdutos', previewProdutos)
    }

    return http.post('integrations/receitas-excel/importar', formData, {
      headers: {
        Authorization: token,
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  emitirReceita: (token, payload) => {
    return http.post('nfes/emitir-receita', payload, {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    })
  },
  calcularAplicacao: (token, payload) => {
    return http.post('calculos/aplicacao', payload, {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    })
  },
}
